import { Outlet } from 'react-router-dom'

import DashboardLayout from '../../shared/components/ui/dashboard-layout'

const Hr = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  )
}

export default Hr
